export default "__VITE_ASSET__20902468__"